import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/kit/coins.png");
;
import(/* webpackMode: "eager" */ "/app/public/kit/download-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/kit/EVM-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/kit/icon-main-color.png");
;
import(/* webpackMode: "eager" */ "/app/public/kit/line-01.svg");
;
import(/* webpackMode: "eager" */ "/app/public/kit/line-02.svg");
;
import(/* webpackMode: "eager" */ "/app/public/kit/line-03.svg");
;
import(/* webpackMode: "eager" */ "/app/public/kit/line-04.svg");
;
import(/* webpackMode: "eager" */ "/app/public/kit/line-05.svg");
;
import(/* webpackMode: "eager" */ "/app/public/kit/near-protocol-near-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/kit/phone-mockup.png");
;
import(/* webpackMode: "eager" */ "/app/public/kit/sweat-main-logo.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(static)/media-kit/Faces.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(static)/media-kit/styles.module.css");
